/**
 * U2-S1b — raccordement fiche U1 → parcours remboursement ROUTE-2 (C&C encaissé magasin).
 * Feature flag OFF par défaut. Exécution via modal SAV caisse (POST rembourser-surplace).
 */

export function isU2S1bWebEncaisseFromUnifiedEnabled() {
  const env =
    typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env : {};
  return env.VITE_U2_S1B_WEB_ENCAISSE_FROM_UNIFIED === 'true';
}

export function mapWebEncaisseRefundBlockReason(reason) {
  switch (reason) {
    case 'INSUFFICIENT_REFUND_PERMISSION':
      return 'Droits insuffisants pour effectuer un remboursement.';
    case 'NOTHING_REFUNDABLE':
      return 'Aucun montant remboursable restant sur cette commande.';
    case 'STRIPE_USE_WEB_REFUND':
      return 'Commande Stripe — remboursement via Mes Commandes uniquement.';
    case 'REFUND_MIXED_TENDERS_BLOCKED':
      return 'Paiement mixte — remboursement indisponible depuis la caisse.';
    case 'WEB_SURPLACE_NOT_ENCAISSE':
      return 'Aucun encaissement magasin traçable pour cette commande.';
    case 'NOT_WEB_ENCAISSE_ORDER':
      return 'Cette vente n’est pas éligible au remboursement caisse ROUTE-2.';
    case 'NOT_POS_ORDER':
      return 'Utilisez le parcours adapté au canal de vente.';
    default:
      return reason
        ? 'Remboursement caisse indisponible pour cette vente.'
        : 'Remboursement caisse indisponible.';
  }
}

/**
 * @param {object} preview
 * @param {boolean} [flagEnabled]
 * @returns {{ kind: 'hidden'|'disabled_flag'|'disabled_server'|'action', commandeId?: string, message?: string }}
 */
export function resolveU2S1bWebEncaisseHandoff(preview, flagEnabled = isU2S1bWebEncaisseFromUnifiedEnabled()) {
  if (!preview?.commande?.id) {
    return { kind: 'hidden' };
  }
  const webAction = preview.allowedActions?.webEncaisseRefund;
  if (!webAction) {
    return { kind: 'hidden' };
  }
  if (!flagEnabled) {
    return {
      kind: 'disabled_flag',
      message:
        'Le raccordement remboursement C&C depuis cette fiche est désactivé (feature flag). Utilisez l’historique caisse ou Mes commandes.',
    };
  }
  if (preview.meta?.u2S1bWebEncaisseHandoffPermitted !== true) {
    return {
      kind: 'disabled_server',
      message:
        'Raccordement U1 → remboursement C&C non activé pour cette boutique (confinement serveur).',
    };
  }
  if (webAction.available !== true) {
    return {
      kind: 'disabled_server',
      message: mapWebEncaisseRefundBlockReason(webAction.reason),
    };
  }
  const solde = Number(preview.financeSummary?.soldeRemboursable) || 0;
  if (solde <= 0) {
    return {
      kind: 'disabled_server',
      message: mapWebEncaisseRefundBlockReason('NOTHING_REFUNDABLE'),
    };
  }
  return {
    kind: 'action',
    commandeId: preview.commande.id,
  };
}
